import React, { useState } from "react";
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";
import { Link } from "react-router-dom";

import Image1 from "../assets/images/corrbox.jpeg";
import Image2 from "../assets/images/profile 2.webp";
import Image3 from "../assets/images/profle 3.jpg";
import Image4 from "../assets/images/profile 4.webp";
import Image5 from "../assets/images/profile5.png";
import Image6 from "../assets/images/metalpack.jpeg";
import Image7 from "../assets/images/Profile7.webp";
import Image8 from "../assets/images/profile8.avif";

import Cta from "./Cta";

const images = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
];

export default function Portfolio() {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  const projectList = [
    { image: Image1 },
    { image: Image2 },
    { image: Image3 },
    { image: Image4 },
    { image: Image5 },
    { image: Image6 },
    { image: Image7 },
    { image: Image8 },
  ];

  return (
    <>
      <section
        className="relative md:py-12 py-8 bg-gray-50 dark:bg-slate-800 active"
        id="portfolio"
      >
        <div className="container">
          <div className="grid grid-cols-1 pb-8 text-center">
            <h6 className="text-[#69A41D] text-[16px] font-medium uppercase mt-12 md:mt-16 lg:mt-24 mb-2">
              Portfolio
            </h6>

            <h3 className="mb-4 mt-4 text-[40px] font-medium text-[#18443A] leading-tight md:leading-normal">
              Our Packaging Solutions in Action
            </h3>

            <p className="text-slate-400 dark:text-slate-300 text-[18px] mt-4 mb-[14px] max-w-xl mx-auto">
              Explore the High-Quality Packaging Projects we have Delivered
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2 gap-6 mt-8">
            {projectList.map((item, index) => (
              <div
                key={index}
                onClick={() => handleClick(index)}
                className="relative rounded-md shadow-sm overflow-hidden group cursor-pointer"
              >
                <img
                  src={item.image}
                  className="w-full h-[300px] object-cover group-hover:scale-110 group-hover:rotate-3 transition duration-500"
                  alt={`workimage-${index + 1}`}
                />

                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-40 transition duration-500 z-0"></div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-10">
            <Link
              to="case-studies"
              className="btn bg-[#18443A] border-[#18443A] hover:border-[#18443A] text-white rounded-md font-bold text-[16px] mb-24"
            >
              View More
            </Link>
          </div>

          {isOpen && (
            <Lightbox
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + images.length - 1) % images.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % images.length)
              }
            />
          )}
        </div>
      </section>

      <Cta />
    </>
  );
}